import { render, staticRenderFns } from "./ActionCat.vue?vue&type=template&id=4bff43ec"
import script from "./actioncat.js?vue&type=script&lang=js&external"
export * from "./actioncat.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports